<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <!-- <el-form-item prop="isQueryExceed">
      <el-checkbox
        v-model="filters.isQueryExceed"
        key="checkbox"
        border
        @change="checkChange"
        >同一天学时数超过8
      </el-checkbox>
    </el-form-item> -->
    <el-form-item prop="deptName">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts"
      >
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.userName"
        placeholder="姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.lectureName"
        placeholder="学习名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree 
      ref="deptTree" 
      :defaultCheckedKeys="defaultCheckedKeys"
      :showModal="deptDialog" 
      @deptSelected="selectDept"
      showTooltip/>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import SingleCheckTree from "../../components/tree/singleCheckTree.vue";
export default {
  name: "search",
  components: {
    butn,
    SingleCheckTree
  },
  data() {
    return {
      size: "small",
      filters: {
        isQueryExceed: false,
        deptLevelCodeQuery: null,
        userName: '',
        lectureName: '',
      },
      deptName: "",
      deptDialog: {
        flag: false,
      },
      defaultCheckedKeys: [],
    };
  },
  watch: {
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
  },
  methods: {
    initData() {
      let params = { ...this.filters };
      params.isQueryExceed = params.isQueryExceed ? 1 : 0;
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {
        isQueryExceed: false,
      };
      this.deptName = "";
      this.clearDepts();
      this.$emit("search", { t: new Date().getTime() });
    },
    checkChange() {
      this.initData();
    },
    
    showDeptModal() {
      this.deptDialog.flag = true;
      this.$nextTick(()=> {
        this.$refs.deptTree.$refs["deptTree"]?.setCheckedKeys(this.defaultCheckedKeys);
      })
    },

    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    },

    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(()=> {
        this.$refs.deptTree.$refs["deptTree"]?.setCheckedKeys(this.defaultCheckedKeys);
      })
    },
  },
};
</script>
